import * as React from 'react'
import { Routes, Route } from 'react-router-dom'

import LoginPage from '@pages/login/Login.page'
import NotFoundPage from '@pages/notFound/NotFound.page'
import DashboardPage from '@pages/dashboard/Dashboard.page'

import Layout from '@components/layout/Layout.component'
import SSOValidator from '@components/ssoValidator/SSOValidator'
import ProtectedRoute from './Protected.route'

const MainRoutes: React.FC = () => {
    return (
        <Routes>
            {process.env.NODE_ENV === 'development' && <Route element={<SSOValidator />} path="/" />}
            <Route element={<Layout />}>
                <Route element={<ProtectedRoute />}>
                    <Route element={<DashboardPage />} path="/dashboard" />
                </Route>
                <Route element={<LoginPage />} path="/login" />
                <Route element={<NotFoundPage />} path="*" />
            </Route>
        </Routes>
    )
}

export default MainRoutes
